// extracted by mini-css-extract-plugin
export var standaloneTable = "_fy-0";
export var withExtraHeader = "_fy-1";